import "sticky-kit/dist/sticky-kit";

let tabletMaxWidthScreen = window.matchMedia("(max-width: 991px)");
let desktopMinWidthScreen = window.matchMedia("(min-width: 992px)");
let $stickyElementInit = $(".collapse-content-list .image-wrap .row");

function initSticky() {
  if (desktopMinWidthScreen.matches) {
    $stickyElementInit.stick_in_parent({
      offset_top: 92,
      // inner_scrolling: true,
    });
  } else {
    $stickyElementInit.trigger("sticky_kit:detach");
  }
}

$(document).ready(function () {
  initSticky();

  $(".collapse-content-list .item").click(function () {
    if (!$(this).hasClass("active")) {
      let offsetBefore = $(this).offset();

      if (tabletMaxWidthScreen.matches) {
        $(this).find("p").show();
        $(this).siblings(".item").find("p").hide();
        $(this).siblings(".item").find("ul").hide();
      } else {
        $(this).find("p").slideDown({
          duration: 300,
        });
        $(this).find("ul").slideDown({
          duration: 300,
        });

        $(this).siblings(".item").find("p").slideUp({
          duration: 300,
        });
        $(this).siblings(".item").find("ul").slideUp({
          duration: 300,
        });
      }

      $(this).addClass("active");
      $(this).siblings(".item").removeClass("active");

      let offsetAfter = $(this).offset();
      let scrollAmount = offsetAfter.top - offsetBefore.top;

      if (tabletMaxWidthScreen.matches) {
        $("html, body").scrollTop($(window).scrollTop() + scrollAmount);
      }

      if (desktopMinWidthScreen.matches) {
        setTimeout(function () {
          $(window).trigger("resize");
        }, 300);
      }
    }
  });

  // lazyLoadElements.on('load error', function() {
  //   $(window).trigger('resize');
  // });
});

$(window).on("resize", function () {
  initSticky();
});
